/**
 * Ambiance: ciel et eclairage derriere une seule facade.
 *
 * C'est le seul objet a brancher dans la boucle de rendu:
 *
 *   const ambiance = new Ambiance(scene)
 *   // chaque frame, apres avoir place la camera:
 *   ambiance.maj(horloge, joueur.position, camera.position, azimutCamera, biome.couleurBrume)
 *   // et pour tout ce qui reagit a la nuit:
 *   const nuit = ambiance.facteurNuit
 */
import type * as THREE from 'three'
import type { Horloge } from '../../shared/sim/temps.ts'
import { Ciel } from './ciel.ts'
import { Lumiere } from './lumiere.ts'

export class Ambiance {
  readonly ciel: Ciel
  readonly lumiere: Lumiere

  constructor(scene: THREE.Scene) {
    this.ciel = new Ciel(scene)
    this.lumiere = new Lumiere(scene)
  }

  /**
   * 0 en plein jour, 1 au coeur de la nuit. Voir Lumiere.facteurNuit.
   */
  get facteurNuit(): number {
    return this.lumiere.facteurNuit
  }

  /**
   * @param h horloge du jeu (shared/sim/temps.ts)
   * @param cibleJoueur position du joueur: centre du frustum d'ombre
   * @param positionCamera position de la camera: centre du dome de ciel
   * @param azimutCamera azimut de la camera en radians (CAM_AZIMUTH au depart)
   * @param couleurBiome couleur de brume du biome courant, melangee a 35 %
   * @param camera si fournie, le frustum d'ombre s'elargit a ce qu'elle montre
   */
  maj(
    h: Horloge,
    cibleJoueur: THREE.Vector3,
    positionCamera: THREE.Vector3,
    azimutCamera: number,
    couleurBiome?: number,
    camera?: THREE.OrthographicCamera,
  ): void {
    this.ciel.suivre(positionCamera)
    this.ciel.maj(h, azimutCamera)
    this.lumiere.maj(h, cibleJoueur, couleurBiome, camera)
  }

  dispose(): void {
    this.ciel.dispose()
    this.lumiere.dispose()
  }
}
